// OTel instrumentation — DEVE ser o primeiro import. Captura traces de
// document-load, fetch e XHR; propaga `traceparent` pra Rocky.WebAPI.
import { initTelemetria } from './otel/instrumentation';

import { createRoot } from 'react-dom/client';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

// style.scss
import 'assets/style.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import { msalInstance } from 'modules/auth/services/msalConfig';
import { authService } from 'modules/auth/services/authService';
import { consumirRetornoAposLogin, ehVoltaDeJanelaAuxiliarDoMsal, marcarSessaoViaEntra } from 'modules/auth/services/renovacaoSessao';
import { registrarRecuperacaoDeChunk } from 'utils/chunkReload';

async function bootstrap() {
  const container = document.getElementById('root');
  if (!container) throw new Error('Root element not found');
  const root = createRoot(container);

  await msalInstance.initialize();

  try {
    const result = await msalInstance.handleRedirectPromise();
    if (result && result.idToken) {
      console.log('[MSAL] redirect resolved, exchanging at backend');
      try {
        const data = await authService.ssoExchange(result.idToken);
        authService.setToken(data.token);
        authService.setUser(data.user);
        marcarSessaoViaEntra(data.user.email);
        // Fluxo OAuth (conector MCP): se o login foi iniciado por um authorize, volta pra lá.
        const oauthReturn = sessionStorage.getItem('rocky_oauth_return');
        if (oauthReturn) {
          sessionStorage.removeItem('rocky_oauth_return');
          await authService.completeOAuthSession(oauthReturn);
        } else {
          // Volta para onde a pessoa estava antes do redirect (renovação ou login), não sempre para '/'.
          window.location.replace(consumirRetornoAposLogin());
        }
        return;
      } catch (e) {
        console.error('[MSAL] ssoExchange error', e);
        sessionStorage.setItem('rocky_sso_error', (e instanceof Error ? e.message : null) || 'Falha no SSO.');
        window.location.replace('/login');
        return;
      }
    }
  } catch (e) {
    console.error('[MSAL] handleRedirectPromise error', e);
  }

  root.render(
    <ConfigProvider>
      <App />
    </ConfigProvider>
  );
}

if (ehVoltaDeJanelaAuxiliarDoMsal()) {
  // Volta do Entra no iframe da renovação silenciosa ou no popup do "Continuar conectado": esta
  // página só repassa a resposta para a aba do app (redirect-bridge do MSAL v5) e se fecha. O app
  // não sobe aqui, nem a telemetria. Se o navegador não deixar o popup se fechar, fica um recado
  // em vez de uma janela em branco.
  const recado = (texto: string) => {
    const root = document.getElementById('root');
    if (root) root.textContent = texto;
  };
  broadcastResponseToMainFrame()
    .then(() => recado('Pronto. Pode fechar esta janela e voltar ao Rocky.'))
    .catch((e) => {
      console.error('[MSAL] redirect-bridge', e);
      recado('Não deu para concluir. Feche esta janela e tente de novo no Rocky.');
    });
} else {
  initTelemetria();
  // Recupera de chunks lazy obsoletos após um deploy (recarrega uma vez para pegar o build novo).
  registrarRecuperacaoDeChunk();
  bootstrap();
  reportWebVitals();
}
